export default __webpack_public_path__ + "static/quickGuideImage-05dd3d51a18692852b61e1a00cf417d4.png";